module.exports = __webpack_public_path__ + "static/img/22h.2c12255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22h.jpg
// module id = R2/q
// module chunks = 0